module.exports = __webpack_public_path__ + "img/imaginedragon.0cb80496.jpg";